module.exports = ".motivo-rechazo-form{width:100%}mat-form-field{width:100%}\n"